module.exports = {
	"next": "volgende",
	"skip": "Spring naar de Cozy creatie",
	"cancel": "annuleren",
	"back": "terug",
	"sign up": "registreren",
	"add email": "voeg een e-mail account toe",
	"welcome": "laat me erin!",
	"confirm": "bevestigen",
	"user missing properties": "Sorry, maar deze gebruiker bestaat niet.",
	"step welcome user": "Welkom %{name}!",
	"step welcome anon": "Welkom!",
	"step welcome logout": "Ben je %{name} niet?",
	"step welcome congrats": "Gefeliciteerd, dankzij jou, zijn jouw persoonlijke gegevens op een veilige plek, in jouw Cozy.",
	"step welcome next": "Volgende",
	"step agreement title": "Algemene voorwaarden",
	"step agreement subtitle": "On toegang te krijgen tot jouw Cozy moet je de algemene voorwaarden lezen en er mee accoord gaan. Omdat geen gewoon mens dit kan, hebben we hier een kleine samenvatting gemaakt voor je:",
	"step agreement element 0": "Neem de controle en verantwoordelijkheid van jouw gegevens, in je eigen huis!",
	"step agreement element 1": "We zorgen voor jouw en jouw Cozy...",
	"step agreement element 2": "...tenzij je iets verkeerd doet met Cozy of jouw gegevens",
	"step agreement element 3": "Kies welke diensten jouw gegevens mogen gebruiken en begrijp hun doel",
	"step agreement element 4": "Niemand (zelfs wij niet) kan toegang krijgen tot de gegevens in jouw Cozy",
	"step agreement element 5": "We weten maar een paar dingen van je, alleen voor juridische redenen of om de kwaliteit van onze dienstverlening te verbeteren",
	"step agreement stats": "Ik geef Cozy toestemming om anoniem gegevens te verzamelen",
	"step agreement description 1": "Je kunt de algemene voorwaarden raadplegen",
	"step agreement description 2": "Door op de knop \"Accepteer\" te klikken, bevestig je dat je deze voorwaarden gelezen hebt, begrepen hebt en er mee akkoord gaat dat je je hier aan zult houden.",
	"step agreement description link": "hier.",
	"step agreement next": "Accepteer",
	"step preset": "instellingen",
	"step import": "importeer je datas",
	"step email settings": "configureer je e-mail",
	"preset email": "e-mail",
	"preset email tip": "Het zal gebruikt worden om contact me je op te nemen als je je wachtwoord kwijt bent.",
	"preset name": "naam",
	"step password empty": "De waarde van het wachtwoord veld mist.",
	"step password too weak": "Jouw wachtwoord is te zwak. Het moet een hoofdletter, een getal, een speciaal karakter of een langer wachtwoord.",
	"step password title": "Beveilig jouw wachtwoord",
	"step password label": "wachtwoord",
	"step password input placeholder": "bijv. \"dEj875ghj9273;eR\"",
	"step password submit": "bevestig",
	"step password show": "Toon wachtwoord",
	"step password hide": "Verberg wachtwoord",
	"step password description": "Jouw wachtwoord moet zo moeilijk mogelijk zijn. Het voorkomt dat kwaadwilligen toegang krijgen tot jouw Cozy. Het gebruik van een hoofdletter, een nummer en een speciaal karakter zijn verplicht.",
	"step password server error": "Er is iets fout gegaan. Jouw wachtwoord is niet opgeslagen.",
	"step infos title": "Complementteer jouw Cozy",
	"step infos description": "Sommige informatie is nodig op jouw Cozy op te zetten.",
	"step infos public_name label": "Gebruikersnaam",
	"step infos public_name placeholder": "De zichtbare naam waarmee Cozy je aan zal spreken.",
	"step infos email label": "E-mail",
	"step infos email placeholder": "Dit wordt gebruikt door Cozy om jouw wachtwoord te herstellen.",
	"step infos timezone label": "Tijdszone",
	"step infos timezone placeholder": "Jouw tijdszone helpt je om de kalender juist weer te geven.",
	"step infos submit": "Bevestig",
	"step infos fetch data error": "Kan de gegevens niet ophalen van de server.",
	"missing public_name": "Je moet jouw gebruikersnaam invullen.",
	"missing email": "Je moet jouw e-mail adres invullen.",
	"invalid email format": "Jouw e-mail adres lijkt niet te kloppen.",
	"missing timezone": "JE moet een tijdszone kiezen.",
	"invalid timezone": "Jouw tijdszone lijkt niet te kloppen.",
	"step accounts title": "Jouw Cozy is succesvol gecreëerd!",
	"step accounts description line 1": "Nu zullen we je begeleiden met het verbinden van jouw Cozy met jouw diensten.",
	"step accounts description line 2": "Uiteindelijk is het Cozy's doel om je jouw gegevens terug te pakken!",
	"step accounts next": "Doorbladeren",
	"myaccounts info": "Je kunt nu jouw Cozy op elk moment bereiken door op 'Verder' te klikken",
	"myaccounts next": "Verder",
	"step confirmation title": "Welkom op jouw persoonlijke cloud!",
	"step confirmation description line 1": "Jouw Cozy is nu klaar.",
	"step confirmation description line 2": "Je kunt je gegevens terug pakken van vele diensten, en installeer de toepassingen die je wilt vanuit onze winkel.",
	"step confirmation next": "Kom binnen",
	"step server error": "Er is een fout opgetreden tijdens het opslaan van jouw voortgang. Het herladen van de pagina zou het probleem moeten oplossen.",
	"preset name tip": "Het wordt getoond als je bestanden deelt met personen of ze uitnodigt voor gebeurtenissen.",
	"preset password": "wachtwoord",
	"preset password tip": "Een sterk wachtwoord van minimaal 8 karakters is vereist (speciale karakters worden aangeraden).",
	"preset timezone": "tijdszone",
	"preset timezone tip": "Je tijdszone is nodig om de gebeurtenissen in jouw agenda correct te kunnen tonen.",
	"preset opt-in help": "Sta toe om statistieken over het gebruik van mijn Cozy te gebruiken om het product te verbeteren.",
	"preset opt-out newsletter": "Meld je aan voor de Beta Cozy nieuwsbrief (ten zeerste aangeraden).",
	"import from google": "Importeer mijn data van mijn Google account",
	"import google account": "Synchroniseer jouw Google account & importeer kalender, contacten en foto's uit Google.",
	"import google account tip": "Je moet inloggen met je Google account om Cozy toegang te geventot jouw data uit Google",
	"leave google title": "Voed je gegevens in Cozy",
	"leave google help me": "Ik begrijp niet wat ik moet doen, help me alsjeblieft!",
	"leave google sign in content": "Log in op je Google account en autoriseer jouw Cozy. Je krijg een complexe tekenreeks. Kopieer dat naar het klembord.",
	"leave google sign in": "Log in op Google",
	"leave google code content": "Dan, kopieer en plak de code uit de pop-up in dit veld:",
	"leave google code": "google code",
	"leave google url doc": "https://docs.cozy.io/en/mobile/import-google.html",
	"leave google choice": "Kies wat je wilt doen met jouw data die is opgeslagen op Google servers:",
	"leave google choice sync gmail": "GMail - Toegang tot je e-mail vanuit Cozy",
	"leave google choice contacts": "Eenmalige import van je Google contacten",
	"leave google choice calendar": "Eenmalige import van je Google kalender",
	"leave google choice photos": "Eenmalige import van je Google foto's",
	"leave google confirm": "Importeer data",
	"import error": "Er is een fout opgetreden tijdens het importeren van jouw data. Probeer het later opnieuw vanuit de gespecialiseerde app.",
	"login welcome user": "Welkom %{username}",
	"login welcome anon": "Welkom",
	"login enter your password": "Voer je wachtwoord in om toegang tot jouw Cozy te krijgen",
	"login password": "wachtwoord",
	"login otp": "Authenticatie code",
	"login submit": "Log in",
	"login auth success": "Authenticatie succesvol, laten we naar binnen gaan!",
	"login recover": "Wachtwoord vergeten? Stuur me een e-mail om het te veranderen.",
	"login recover busy": "E-mail aan het sturen met instructies",
	"login recover sent title": "E-mail is verstuurd",
	"login recover sent message": "Controleer je e-mail, volg de instructies om je wachtwoord te herstellen",
	"login recover error title": "Fout bij versturen van e-mail",
	"login recover error message": "Fout bij het versturen van het wachtwoord herstelbericht, kijk of je mail server draait of neem contact op met de systeembeheerder",
	"login wrong password title": "Verkeerde inloggegevens",
	"login wrong password message": "De inloggegevens die je ingevoerd hebt zijn onjuist. Probeer het opnieuw.",
	"login server error": "Er is een fout opgetreden, probeer het opnieuw.",
	"reset password request success title": "E-mail verstuurd",
	"reset password request success message": "Controleer je e-mails en volg de instructies om jouw wachtwoord te veranderen.",
	"reset password request error": "Er is een fout opgetreden, de e-mail is niet verstuurd. Probeer het opnieuw. Als de fout blijft optreden, neem dan contact met ons op via contact@cozycloud.cc.",
	"reset welcome user": "Verander jouw wachtwoord",
	"reset enter your password": "%{username}, stel een nieuw wachtwoord in om de toegang tot jouw Cozy terug te krijgen.",
	"reset password": "wachtwoord",
	"reset submit": "herstel je wachtwoord",
	"reset auth success": "wachtwoord succesvol hersteld",
	"reset wrong password title": "Je wachtwoord kon niet worden hersteld",
	"reset wrong password message": "Het wachtwoord dat je ingevuld hebt is verkeerd, of het herstelbewijs is verlopen",
	"reset password error invalid key": "Het herstelbewijs is verlopen. Vraag alsjeblieft een nieuwe aan.",
	"reset password error password too weak": "Jouw wachtwoord is te zwak. Je moet een hoofdletter, een getal, een speciaal karakter or een langer wachtwoord gebruiken.",
	"setup title": "We stellen jouw Cozy in...",
	"setup message": "Je staan nu dicht bij jouw eigen privé cloud, waar jouw data opgeslagen wordt.",
	"setup on mobile title": "Synchroniseer je data met je Android apparaat!",
	"setup on mobile message": "Bekijk onze mobiele app op Google Play:",
	"welcome title": "Gefeliciteerd met het terugwinnen van het beheer van jouw eigen data!",
	"welcome message": "Je kunt nu jouw data opslaan op je privé cloud. In tegenstelling tot de meeste cloud diensten, wordt er geen analyse gedaan op de data in jouw Cozy."
};


//////////////////
// WEBPACK FOOTER
// ./app/locales/nl.json
// module id = 45
// module chunks = 0